import { createEvent, createStore } from 'effector'

export const actions = {
  setPlaces: createEvent<LocalisationResponse[]>('setPlaces'),
  setPlacesTree: createEvent<LocationTreeItem[]>('setPlacesTree'),
  resetPlaces: createEvent('resetPlaces'),
  reset: createEvent('reset'),
}

const initialState: LocationState = {
  places: [],
  tree: [],
}

export const store = createStore<LocationState>(initialState, { name: 'location' })
  .on(actions.setPlaces, (s, places) => ({ ...s, places }))
  .on(actions.setPlacesTree, (s, tree) => ({ ...s, tree }))
  .on(actions.resetPlaces, (s) => ({ ...s, places: initialState.places }))
  .reset(actions.reset)
